import styled, {css} from 'styled-components';
import {dFlex, dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const list = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    ${dFlexColumn};
    gap: var(--space-xl);
    padding: 0 var(--space-xl) var(--space-md);
`;

export const day = styled.section`
    ${dFlexColumn};
    flex: none;
    gap: var(--space-sm);
`;

export const dayTitle = styled.h3`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-bold);
    line-height: 1.4;
    text-align: start;
    padding-bottom: var(--space-xs);
    border-bottom: 1px solid var(--color-border-subtle);
`;

/* One session; the producer's session color (if any) marks the row's leading edge */
export const row = styled.div<{$color?: string}>`
    ${dFlex};
    gap: var(--space-md);
    padding: var(--space-md);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--border-radius-border-radius-md);
    background: var(--color-bg-base-alt);
    ${p => p.$color && css`
        border-inline-start: 4px solid ${p.$color};
    `}
`;

export const time = styled.b`
    flex: none;
    min-width: 44px;
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-bold);
    line-height: 1.25;
    text-align: center;
    direction: ltr;
`;

export const text = styled.div`
    ${dFlexColumn};
    flex: 1 1 0;
    min-width: 0;
    gap: var(--space-xs);
    text-align: start;
`;

export const title = styled.span`
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-bold);
    line-height: 1.25;
    word-break: break-word;
`;

export const meta = styled.span`
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    color: var(--color-text-subtle);
    line-height: 1.4;
    word-break: break-word;
`;

export const link = styled.a`
    font-size: var(--font-size-caption);
    color: var(--color-text-default);
    text-decoration: underline;
    word-break: break-all;
`;
